<template>
  <div class="chart-card">
    <div class="chart-card__header">
      <div>
        <h3 class="chart-card__title">{{ title }}</h3>
        <p class="chart-card__subtitle">{{ subtitle }}</p>
      </div>
    </div>
    <div class="chart-card__body">
      <div v-if="!hasData" class="chart-card__empty">
        <font-awesome-icon icon="th" class="chart-card__empty-icon" />
        <p>Ingen data tilgjengelig</p>
      </div>
      <apexchart
        v-else
        type="heatmap"
        :height="height"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts';

export default {
  name: 'HourlyHeatmapChart',
  components: { apexchart: VueApexCharts },
  props: {
    title: { type: String, default: 'Salgsvarme' },
    subtitle: { type: String, default: 'Omsetning per time og ukedag' },
    data: {
      type: Array,
      default: () => []
      // Expected format: [
      //   { name: 'Man', data: [{x: '08', y: 1000}, {x: '09', y: 2000}, ...] },
      //   { name: 'Tir', data: [...] },
      //   ...
      // ]
    },
    height: { type: Number, default: 280 }
  },
  computed: {
    hasData() {
      return this.data && this.data.length > 0;
    },
    series() {
      return this.data;
    },
    chartOptions() {
      return {
        chart: {
          type: 'heatmap',
          toolbar: { show: false },
          fontFamily: 'inherit'
        },
        dataLabels: { enabled: false },
        colors: ['#B30E10'],
        plotOptions: {
          heatmap: {
            shadeIntensity: 0.5,
            radius: 4,
            colorScale: {
              ranges: [
                { from: 0, to: 0, color: 'var(--bo-surface-2)', name: 'Ingen' },
                { from: 1, to: 1000, color: '#fecaca', name: 'Lav' },
                { from: 1001, to: 5000, color: '#f87171', name: 'Middels' },
                { from: 5001, to: 15000, color: '#dc2626', name: 'Høy' },
                { from: 15001, to: 1000000, color: '#7f1d1d', name: 'Veldig høy' }
              ]
            }
          }
        },
        stroke: {
          width: 2,
          colors: ['var(--bo-surface)']
        },
        xaxis: {
          type: 'category',
          labels: {
            style: {
              colors: 'var(--bo-muted)',
              fontSize: '11px'
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: 'var(--bo-muted)',
              fontSize: '11px'
            }
          }
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return new Intl.NumberFormat('nb-NO').format(Math.round(val)) + ' kr';
            }
          }
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center'
        }
      };
    }
  }
};
</script>

<style scoped>
.chart-card {
  background: var(--bo-surface);
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.chart-card__header {
  padding: 20px 20px 0 20px;
}

.chart-card__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--bo-ink);
  margin: 0 0 4px 0;
}

.chart-card__subtitle {
  font-size: 13px;
  color: var(--bo-muted);
  margin: 0;
}

.chart-card__body {
  padding: 16px 20px 20px;
}

.chart-card__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: var(--bo-muted-2);
}

.chart-card__empty-icon {
  font-size: 32px;
  margin-bottom: 12px;
}
</style>
